import { X } from "lucide-react";
import React from "react";
import ConnectWithUsBtns from "./ConnectWithUsBtns";



export default function ThankYouWithCTA({leadThemeObject, name = "", details = "We'll contact you soon.", onReturn,redirectToDashboard }) {
  return (
    <div className="ty-root">
      <style>{`
      .ty-root{position:absolute;z-index:999999;top:0px;left:0px;right:0px;bottom:0px;;}
        .ty-root{
          display:flex;align-items:center;justify-content:center;
          font-family: Arial, sans-serif;
          background:#f9fafb;
          color:#333;
          padding:20px;
        }
        .ty-card{  position:relative;
          max-width:500px;
          width:100%;
          background:${leadThemeObject?.thankYouPage?.cardBG?.color};
          border-radius:8px;
          box-shadow:0 4px 12px rgba(0,0,0,0.08);
          padding:30px;
          text-align:center;
        }
        .ty-icon{
          width:70px;height:70px; margin:0 auto 20px auto; border-radius:50%;
          background:#f1f1f1; display:flex;align-items:center;justify-content:center;
        }
        .ty-check{
          width:30px;height:15px; border-left:4px solid ${leadThemeObject?.thankYouPage?.subtitleColor?.color};; border-bottom:4px solid ${leadThemeObject?.thankYouPage?.subtitleColor?.color};;
          transform:rotate(-45deg);margin-top:-14px;
        }
        .ty-title{font-size:28px;margin:0 0 10px 0;color:${leadThemeObject?.thankYouPage?.titleColor?.color};
         font-family:${leadThemeObject?.thankYouPage?.titleFont?.family?.fontFamily}; }
        .ty-sub{margin:0 0 20px 0;font-size:15px;color:${leadThemeObject?.thankYouPage?.subtitleColor?.color};
         font-family:${leadThemeObject?.thankYouPage?.subtitleFont?.family?.fontFamily};  }
        .ty-sub-cta{margin:0 0 20px 0;font-size:22px;font-weight:900;color:${leadThemeObject?.thankYouPage?.subtitleColor?.color};
         font-family:${leadThemeObject?.thankYouPage?.subtitleFont?.family?.fontFamily};  }
       .ty-sub-cta-two{margin:10px;font-size:13px;font-weight:900;color:${leadThemeObject?.thankYouPage?.titleColor?.color};
         font-family:${leadThemeObject?.thankYouPage?.titleFont?.family?.fontFamily};  }
        .ty-actions{display:flex;gap:12px;justify-content:center}
        .btn{
          padding:10px 18px; border:none; border-radius:26px; font-weight:600; cursor:pointer;
        }
        .btn-refer{background:${leadThemeObject?.thankYouPage?.CTAButton?.refer?.buttonBG?.color};
        font-family:${leadThemeObject?.thankYouPage?.subtitleFont?.family?.fontFamily};;color:#fff }
       .btn-freeDownload{background:${leadThemeObject?.thankYouPage?.CTAButton?.freeDownload?.buttonBG?.color};
        font-family:${leadThemeObject?.thankYouPage?.subtitleFont?.family?.fontFamily}; ;color:#fff}
        .btn-ghost{position:absolute;right:10px;top:10px;color:#fff;cursor:pointer;
        background:#222222;;width:30px;height:30px;border-radius:50%;display:flex;justify-content:center;align-items:center;}
      `}</style>

      <div className="ty-card"><button className=" btn-ghost" onClick={() =>redirectToDashboard()}><X size={20} color={"#ffffff"} /></button>
        <div className="ty-icon"><div className="ty-check"></div></div>
        <h1 className="ty-title">{leadThemeObject?.thankYouPage?.title} </h1>
        <p className="ty-sub">{leadThemeObject?.thankYouPage?.description}</p>
        <p className="ty-sub-cta">{leadThemeObject?.thankYouPage?.CTAButton?.[leadThemeObject?.thankYouPage?.CTAButton?.type]?.title}</p>
        <p className="ty-sub-cta-two">{leadThemeObject?.thankYouPage?.CTAButton?.[leadThemeObject?.thankYouPage?.CTAButton?.type]?.description}</p>
        
        <div className="ty-actions">
          {/* <button className="btn btn-primary" onClick={(e) => { if (onReturn) onReturn(); }}>Return to site</button> */}
              {leadThemeObject?.thankYouPage?.CTAButton?.type=="refer"?
             <button className="btn btn-refer" onClick={(e) => {  }}>{leadThemeObject?.thankYouPage?.CTAButton?.refer?.buttonTitle}</button>:""}
         {leadThemeObject?.thankYouPage?.CTAButton?.type=="connectWithUs"?<ConnectWithUsBtns
       links= { {facebook:leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs?.fb?.link 
       ,youtube:leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs?.YT?.link, 
       x:leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs?.X?.link}} size = "sm" />:"" }
        {leadThemeObject?.thankYouPage?.CTAButton?.type=="freeDownload"?
             <button className="btn btn-freeDownload" onClick={(e) => {  }}>{leadThemeObject?.thankYouPage?.CTAButton?.freeDownload?.buttonTitle}</button>:""}
       
        </div>
          {leadThemeObject?.thankYouPage?.CTAButton?.[leadThemeObject?.thankYouPage?.CTAButton?.type]?.info?<p className="ty-sub-cta-two">{leadThemeObject?.thankYouPage?.CTAButton?.[leadThemeObject?.thankYouPage?.CTAButton?.type]?.info}</p>:""}
   
      </div>
    </div>
  );
}